import {
  Asset_Order_By,
  GetAssetsSubscription,
  GetGeomCabinaQuery,
  GetAssetInCabinaIdsSubscription,
  GetSottoscrizioniProsumerSubscription,
  GetConfigurazioneQuery,
  GetSottoscrizioneProsumerSubscription,
  GetCerDisponibiliProsumerSubscription,
  GetAssetSubscription,
  GetRipartizioniSubscription,
  Order_By,
} from '../../../../_core/_graphql/generated';
import type { DeepPartial } from '@apollo/client/utilities';

export type ProsumerState = {
  assets_data?: GetAssetsSubscription['search_asset'];
  assets_loading: boolean;
  assets_page: number;
  assets_page_size: number;
  assets_total: number;
  assets_search: string;
  assets_order_by: Asset_Order_By[];

  selected_asset_loading: boolean;
  selected_asset?: DeepPartial<GetAssetSubscription['asset_by_pk']>;

  selected_asset_geometria_loading: boolean;
  selected_asset_geometria?: DeepPartial<
    GetGeomCabinaQuery['energy_village_area'][0]
  >;
  selected_asset_energy_village_assets_loading: boolean;
  selected_asset_energy_village_assets?: GetAssetInCabinaIdsSubscription['asset'];

  sottoscrizioni_loading: boolean;
  sottoscrizioni_data?: GetSottoscrizioniProsumerSubscription['sottoscrizione'];
  cer_disponibili_loading: boolean;
  cer_disponibili_data?: GetCerDisponibiliProsumerSubscription['cer'];

  selected_sottoscrizione?: GetSottoscrizioneProsumerSubscription['sottoscrizione_by_pk'];
  selected_sottoscrizione_loading: boolean;

  selected_configurazione?: DeepPartial<GetConfigurazioneQuery['cer_by_pk']>;
  selected_configurazione_loading: boolean;
  selected_configurazione_logo?: string;

  selected_ripartizioni_loading: boolean;
  selected_ripartizioni_data?: DeepPartial<
    GetRipartizioniSubscription['incentivi_calcolati']
  >;

  cer_disponibili_filter: boolean;

  assets_incentivi_totali: Record<string, number>;

  failure?: any;
};

export const initialProsumerState: ProsumerState = {
  assets_data: undefined,
  assets_loading: true,
  assets_page: 0,
  assets_page_size: 10,
  assets_total: 0,
  assets_search: '',
  assets_order_by: [{ created_at: Order_By.Desc }],

  selected_asset_loading: true,
  selected_asset: undefined,

  selected_asset_geometria_loading: true,
  selected_asset_geometria: undefined,
  selected_asset_energy_village_assets_loading: true,
  selected_asset_energy_village_assets: undefined,

  sottoscrizioni_loading: true,
  sottoscrizioni_data: undefined,
  cer_disponibili_loading: true,
  cer_disponibili_data: undefined,

  selected_sottoscrizione_loading: false,
  selected_sottoscrizione: undefined,

  selected_configurazione_loading: true,
  selected_configurazione: undefined,
  selected_configurazione_logo: undefined,

  selected_ripartizioni_loading: true,
  selected_ripartizioni_data: undefined,

  cer_disponibili_filter: false,

  assets_incentivi_totali: {},

  failure: undefined,
};
